import { render, staticRenderFns } from "./paymentClose.vue?vue&type=template&id=74e4c468&scoped=true&"
import script from "./paymentClose.vue?vue&type=script&lang=js&"
export * from "./paymentClose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e4c468",
  null
  
)

export default component.exports